import * as Cookies from 'js-cookie'
import {AppConfig} from "../config";

export class AppCookies {

	static setAccessToken(token: string) {
		Cookies.set(AppConfig().cookies.name, {'key': token});
	}

	static getAccessToken(): string {
		let cookie: any = {}
		try {
			let cookieString = Cookies.get(AppConfig().cookies.name)
			cookie = JSON.parse(cookieString)
		} catch (e) {
			// cookie does not exist or JOSN i bad
		}
		if (cookie.key) return cookie.key
		return null
	}

	static removeCookie() {
		Cookies.remove(AppConfig().cookies.name)
	}
}
